import { basePath } from './config-public';
import { UserRole } from './types/models';

// Concatenate URL path, removing redundant slashes
export const compose = (x: string, ...rest: string[]): string => {
  if (rest.length == 0) return x;
  const y = compose(rest.shift(), ...rest);
  const xx = x.replace(/\/$/, '');
  if (y.startsWith('/')) return xx + y;
  else return xx + '/' + y;
};

export const addBase = (path: string): string => {
  return compose('/' + basePath, path);
};

/*
 *  As far as the Teacher Dashboard is concerned, treat
 *  these two as equivalent.
 */
export const ADMIN_ROLES = [UserRole.admin, UserRole.customerSupport];
